import React from "react";
import type { ModalDialogProps } from "../../types";

function ModalDialog({
  show,
  onClose,
  title,
  children,
  footer,
}: ModalDialogProps) {
  if (!show) return null;

  const handleBackdropClick = (e: React.MouseEvent<HTMLDivElement>) => {
    if (e.target === e.currentTarget) {
      onClose();
    }
  };

  return (
    <div
      className='modal fade show'
      style={{
        display: "block",
        backgroundColor: "rgba(0,0,0,0.5)",
        position: "fixed",
        top: 0,
        left: 0,
        width: "100%",
        height: "100%",
        zIndex: 1050,
      }}
      tabIndex={-1}
      onClick={handleBackdropClick}
    >
      <div
        className='modal-dialog modal-lg modal-dialog-scrollable'
        onClick={e => e.stopPropagation()}
      >
        <div className='modal-content'>
          <div className='modal-header'>
            <h5 className='modal-title'>{title}</h5>
            <button
              type='button'
              className='btn-close'
              onClick={onClose}
              aria-label='Close'
            />
          </div>
          <div className='modal-body'>{children}</div>
          {footer && <div className='modal-footer'>{footer}</div>}
        </div>
      </div>
    </div>
  );
}

export default ModalDialog;
